/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_TagInputs */

const en_gc_search_guides_what_is_gridcraft_tag = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet GridCraft`)
};

const zh_gc_search_guides_what_is_gridcraft_tag = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认识 GridCraft`)
};

/**
* | output |
* | --- |
* | "Meet GridCraft" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_tag = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_tag(inputs)
	return zh_gc_search_guides_what_is_gridcraft_tag(inputs)
});
export { gc_search_guides_what_is_gridcraft_tag as "gc.search_guides.what_is_gridcraft.tag" }